function onclick_select_variant(){
 const product = window.objectData.product;
  const metadata = window.objectData.pro_vari.offers;
 
  //const product = JSON.parse($(selectors.productTemplateID).html());
  $(document).on("change",".pdp-single-option-selector",function() {
    $(this).attr("selected", "selected");
    $(this).siblings().removeAttr("selected");
    get_selected_variant_id(product,metadata);
  });
}

function get_selected_variant_id(product,metadata) {
          
            var option_len = product['options'].length;
             //console.log('length - '+option_len);
            var op1 = null;
            var op2 = null; 
            var op3 = null;
            $(".pdp_variant_selector-wrapper").each(function() {
                var optionIndex = $(this).find(".pdp-single-option-selector").attr('data-index');
                var sel_val = $(this).find(".pdp-single-option-selector option:selected").attr('value');
                    //console.log(optionIndex);
                    var optionValue = sel_val;
                    if(optionIndex=='option1'){
                         op1 = optionValue;
                     }
                     if(optionIndex=='option2'){
                         op2 = optionValue;
                     }
                     if(optionIndex=='option3'){
                         op3 = optionValue;
                     }
            }); // end each loop
                console.log('selected val= '+op1+' -- '+op2+' -- '+op3);
            var variants = product['variants'].filter(function(element,index) {
               return element.option1 == op1 && op2 == element.option2 && element.option3 == op3; 
           });
                
            var variantshh = product['variants'].filter(function(element,index) {
               return op2 == element.option2 && element.option3 == op3; 
           });
  console.log(product);
  
//   let dArray = product.variants.filter(ele=> {return (ele.optiona1 == op2 && ele.option2 == op3)});
   console.log('kkkk',variantshh);
    console.log(variants[0]);
          // update main variant selector  
            $("#Pdp_variant_hidden option").each(function(){
                if($(this).val()==variants[0].id){
                    //$(this).attr('selected','selected');   
                    $(this).prop('selected',true).parent().trigger('change');       
                    $(this).siblings().removeAttr("selected");
      
                  }
              });
  // update plan price 
var indexop = 0;
  console.log(metadata);
  for(let x of variantshh ){
    
    	console.log(x.id);
               let klk = metadata.filter(function (e) {
					 return e.id == x.id;
                  });
		
    if(klk.length) {
      var p = klk[0]['metaprice'] ? klk[0]['metaprice'] : klk[0]['price']
			console.log(p);
     	 $(".options-wrap .options").eq(indexop).find(">h1").html('LE '+p);
      }

       ++indexop;
    }
  
}

 $('.add_to_cart_btn').click(function(){
      var buttonvalue = $(this).attr('data-opt');
       //alert(buttonvalue);
      	$(".pdp-single-option-selector[data-option-name=option_name-Plan] option").each(function(){
          var bar = $(this).val();
         //alert(bar);
          //alert($(this).val());
       		 if($(this).val()==buttonvalue){
             //  alert("asdasdasd");
//        	    $(this).attr('selected',true).parent().trigger("change");   
                 $(this).prop('selected',true).parent().trigger('change');       
         

        	}
    	});
   $('form[data-product-form]').submit();
      })

// Plan Button Subscription Functionality
$(document).ready(function() {

  function selectPlan($btn) {
    $('.np-plan').removeClass('is-selected');
    $btn.addClass('is-selected');

    var planName          = $btn.data('plan-name');
    var planPrice         = $btn.data('plan-price');
    var isSubscription    = $btn.data('is-subscription');
    var subsbaseElementId = $btn.data('subsbase-element-id');
    var variantId         = $btn.data('variant-id');
    var billedNote        = $btn.data('billed');

    var feature1 = $btn.data('feature-one');
    var feature2 = $btn.data('feature-two');
    var feature3 = $btn.data('feature-three');
    var feature4 = $btn.data('feature-four');
    var feature5 = $btn.data('feature-five');

    // Update price card
    $('#npPlanName').text(planName);
    $('#npPrice').text(planPrice);
    $('#npBilled').html(billedNote || '&nbsp;');

    // Update features if variant has them set
    if (feature1 || feature2 || feature3 || feature4 || feature5) {
      var featuresHtml = '<h3>Features</h3><ul>';
      if (feature1) featuresHtml += '<li>' + feature1 + '</li>';
      if (feature2) featuresHtml += '<li>' + feature2 + '</li>';
      if (feature3) featuresHtml += '<li>' + feature3 + '</li>';
      if (feature4) featuresHtml += '<li>' + feature4 + '</li>';
      if (feature5) featuresHtml += '<li>' + feature5 + '</li>';
      featuresHtml += '</ul>';
      $('#npFeatures').html(featuresHtml);
    }

    // Sync hidden variant selector
    $('#Pdp_variant_hidden option').each(function() {
      if ($(this).val() == variantId) {
        $(this).prop('selected', true).parent().trigger('change');
      }
    });

    // Show correct CTA button
    if (isSubscription && subsbaseElementId) {
      $('#addToCartSection').hide();
      $('#npSubscribeAction').show();
      $('#mainSubscribeBtn').data('subsbase-element-id', subsbaseElementId);
    } else {
      $('#npSubscribeAction').hide();
      $('#addToCartSection').show();
      $('#mainAddToCartBtn').data('variant-id', variantId);
    }
  }

  // Plan button click
  $(document).on('click', '.np-plan', function() {
    selectPlan($(this));
  });

  // Subscribe button click — triggers the hidden Subsbase element
  $('#mainSubscribeBtn').on('click', function() {
    var subsbaseElementId = $(this).data('subsbase-element-id');
    if (subsbaseElementId) {
      var $subsbaseBtn = $('#' + subsbaseElementId);
      if ($subsbaseBtn.length) {
        console.log('Triggering Subsbase element:', subsbaseElementId);
        $subsbaseBtn.click();
      } else {
        console.error('Subsbase element not found:', subsbaseElementId);
      }
    }
  });

  // Add to cart button click
  $('#mainAddToCartBtn').on('click', function() {
    var variantId = $(this).data('variant-id');
    if (variantId) {
      $('#Pdp_variant_hidden option').each(function() {
        if ($(this).val() == variantId) {
          $(this).prop('selected', true).parent().trigger('change');
        }
      });
      $('form[data-product-form]').submit();
    }
  });

  // Gallery thumbnail click
  $(document).on('click', '.np-thumb', function() {
    $('.np-thumb').removeClass('is-active');
    $(this).addClass('is-active');
    var src = $(this).data('src');
    if (src) { $('#npMainImg').attr('src', src); }
  });

  // Initialise with the first plan button
  var $firstPlan = $('.np-plan').first();
  if ($firstPlan.length) {
    selectPlan($firstPlan);
  }

});

onclick_select_variant();


